import script from "./CalendarTaskDisplayComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarTaskDisplayComponent.vue?vue&type=script&setup=true&lang=js"

import "./CalendarTaskDisplayComponent.vue?vue&type=style&index=0&id=09d01c30&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09d01c30"]])

export default __exports__